import styled from "styled-components";
// import colors from "assets/scss/colors.scss";

const StyleWrapper = styled.div`
.motor-banner-container {
  text-align:center;
}

.motor-banner {
  width: 100%;
  height: auto;
}

.next-box {
  padding: 24px;
  background: #f2f3f5;
  border-bottom: 2px solid #f2f3f5;
  border-radius: 8px;
  .Dec-Input {
    .p-inputtext {
      border: none;
      width: 100%;
      font-weight: 700;
      // background: #ffffff;
      box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
      border-radius: 4px;
      font-size: 1rem;
      color: #4c565c;
    padding: 1.3rem 0.75rem 0.4rem 0.75rem;
    }
    .p-float-label input:focus ~ label,
    .p-float-label input.p-filled ~ label {
      top: 0.75rem;
      font-size: 0.7rem;
    }
  }
  .Dec-Input{
    label{
      right:12px;
    }
  }
  }
}
    .sections-container{
        lex-direction: column;
        align-items: flex-start;
        padding: 24px;
        background: #FFF;
        box-shadow: 0px 4px 10px rgb(9 30 66 / 6%);
        border-radius: 12px;
        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;

        .promo_section {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .promo_section_div {
            cursor: pointer;

            h5 {
              font-size: 1rem;
              color: ${(props) => (props.businessColor ? props.businessColor : "#6B47F5")};
            }
          }
        }
        
        .vehicles-list{
          overflow: auto;
          
   
          &::-webkit-scrollbar { 
            width: 0;  /* Safari and Chrome */
        }
          .vehicle_card{
            display: inline-flex;
            min-width: 210px;
            height: 75px;
            &.active {
              background: ${(props) => (props.businessColor ? props.businessColor : "#6B47F5")};
            }
          }
        }

        .vehicles-list-control{
            
            .prev,.next{
                background: transparent;
                color: #818B9B;
                margin: 0 20px;
                box-shadow:none !important;
                border:none !important;
            }

            .view-all{
                background: transparent;
                color: ${(props) => (props.businessColor ? props.businessColor : "#6B47F5")};
                margin: 0 20px;
                box-shadow:none !important;
                border-color: ${(props) => (props.businessColor ? props.businessColor : "#6B47F5")};
            }
        }
    }
    .apply-promo-btn{
        color:${(props) => (props.businessColor ? props.businessColor : "#6B47F5")} !important;
        outline:none !important;
        box-shadow:none !important;
        &:hover{
            color:${(props) => (props.businessColor ? props.businessColor : "#6B47F5")} !important;
            outline:none !important;
            box-shadow:none !important;
        }
    }


    .product_wrapper{
        display: flex;
        width: 100%;
    }
    .covers_wrapper{
        display: flex;
        width: 70%;
        gap: 1rem;
        flex-wrap: wrap;
    }

    .drive-label{
  margin-left: 10px;
}

.declaration-label{
  margin-left: 10px;
}

.p-calendar {
  z-index: 0 !important;
}




    .vehicle-item{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding:  1rem;
        background: #F2F3F5;
        border-radius: 8px;
        width:100%;
        margin: 1rem 0;
        &.missing{
          border: 1px solid #C4314B;
        }
    
        .vehicle-img{
          border-right:1px solid rgba(26, 28, 31,0.1);
          width:12%;
          padding:0;
        }
        .vehicle-details{
          width: 100%;
          display: flex;
          justify-content: space-between;
        align-items: center;
          .details{
            .title{
              font-size:0.75rem;
              color: #676F7C;
            }
          }
            .plate{
              .plate-wrapper{
                width: 100%;
                max-width: 130px;
                position: relative;
                img{
                  width: 100%
                }
                .numbers{
                  position: absolute;
                  left: 10%;
                  &.en{
                    top:22px;
                  }
                  &.ar{
                    top:1px;
                  }
                }
                .chars{
                  position: absolute;
                  right: 25%;
                  &.ar{
                    top:1px;
                  }
                  &.en{
                    top:22px;
                  }
                }
              }
              & > *{
                float: right;
                position: relative;
                font-size: 13px;
                font-weight: bold;
                top: 5%;

                &.numbers{
                  right: 27%;
                }
              }
    
            }
          }
        }
    
        .vehicle-actions{
          border-left:1px solid rgba(26, 28, 31,0.1);
          width:12%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0;
          margin-left: 10px;
          padding: 0;
          button{
            border:none;
            outline:none;
            box-shadow:none;
            padding:6px;
            margin:0 5px;
            &.edit{
              background: #E3FFEF;
            }
            &.remove{
              background: #FCF4F6;
            }
            &:hover{
              border:none !important;
              outline:none  !important;
              box-shadow:none  !important;
            }
          }
          
        }
    
        form{
          .actions{
            button{
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              // padding: 0px 16px 0px 24px;
              padding:6px 20px;
              width: fit-content;
              outline:none;
              box-shadow:none;
              border-radius: 5px;
              border:none;
          
              &.save-btn{
                background: ${(props) => (props.businessColor ? props.businessColor : "#6B47F5")};
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 0.5rem 2rem;
                color:#FFF;
                svg{
                  width: 20px;
                  height: 20px;
                  margin: 0 5px;
                }
              }
              &.close-btn{
                border:none;
                color:#4C565C;
                margin:0 10px;
                &:hover,&:focus,&:active{
                  background:transparent;
                  border:none;
                  color:#4C565C;
                }
              }
            }
          }
        }
      }
    
      .preview_wrapper{
        //margin-top: 0rem;
        .missing_data{
          position: relative;
          display: inline-block;
          background: #C4314B;
          padding: 8px 18px;
          margin: 0 1rem 0 auto;
          float: right;
          font-family: tawuniya;
          font-size: 12px;
          font-weight: 800;
          line-height: 12px;
          letter-spacing: 0em;
          text-align: center;
          color: #fff;
          border-radius: 12px 6px 0px 0px;
          &::after{
            content: '';
            position: absolute;
            left: 42%;
            top: 100%;
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 10px solid #C4314B;
            clear: both;
        }
        }
      }
      .yomLabel{
        position: absolute;
        top: -1.5rem;
        left: 0.75rem;
        font-size: 0.75rem;
        color:#6c757d;
      }

      .mechanical_wrapper{
        .mbiPlan_card{
          height: auto;
          h4{
            font-weight: bold;
            font-size: 1.5rem;
          }
          h3{
            font-size: 1.5rem !important;
          }
        }
      }
      .mobile-no-direction-ar {
        direction: initial !important;
        text-align: right !important;
      }
      @media only screen and (min-width: 993px){
        .card-option {
          width: 49%;
        }

      }
      @media only screen and (max-width: 568px){
        .vehicle-item .vehicle-img{
          width: 100%;
          display: inline-flex;
          justify-content: center;
          margin-bottom: 1rem;
          border: none;
        }
        .card__wrapper{
          justify-content: center;
          flex-direction: column;
          align-items: center;
          width: 100%;
          display: flex;
          padding: 0;
        }
        .vehicle-details{
          width: 100% !important;
          display: inline-flex;
          justify-content: space-between;
          svg{
            max-width: 50px;
          }
          .details{
            font-size: 0.6rem;
          }
        }
        .plate{
          padding: 0;
        }
        .plate-wrapper{
          img{
            height: 40px;
          }
        }
      }

@media only screen and (max-width: 786px){
  .sections-container{
    background: #F2F3F5;

    .promo_section {
      display: flex;
      flex-direction: column;

      .promo_section_div {
        cursor: pointer;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-top: 1rem;

        h5 {
          font-size: 1rem;
          color: ${(props) => (props.businessColor ? props.businessColor : "#6B47F5")};
        }
      }
    }
  }
    .product_wrapper{
        flex-direction: column;
    }
    .covers_wrapper{
        justify-content: center;
        gap: 0.75rem;
        width: 100%;
        .ProductCoversCard{
            min-width: 45%
        }
    }
    .vehicles-list{
      overflow-x: scroll;
      overflow-y: hidden;
      white-space: nowrap;
        &>div{
            min-width: 16rem;
        }
        overflow-x: auto;
    } 
    .mechanical_wrapper{
      overflow-x: scroll;
    }    
}

&.ar{
  .p-message-close.p-link{
    margin-left:0;
    margin-right: auto;
  }
    font-family: "tawuniya";
    .fm-bliss2-bold{
      font-family: "tawuniya"!important;
    }
    .fm-tawuniya{
      font-family: 'tawuniya' !important;
    }
  .field input.fm-tawuniya{
    &::placeholder{
      font-family: "tawuniya" !important;
    }
  }
  .vehicle-Sum-class{
    cursor: pointer;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px;
    border-radius: 8px;
    background: #FFFFFF;
    width:24%;
    margin:0 5px;    
    border: 1px solid #D9DCE1;
    &.active{
        background: ${(props) => (props.businessColor ? props.businessColor : "#6B47F5")};
        border: 1px solid #D9DCE1;
        color: white;
        .info_wrapper{
            p{color: #fff;}
        }
    }
    .card_wrapper{
        display: flex;
        width: 100%;
        justify-content: center;
        gap: 1.5rem
    
    }
    .info_wrapper{
        display: inline-flex;
        flex-direction: column;
        gap: 0.25rem;
        .plate{
            font-weight: 800;
            font-size: 16px;
            line-height: 120%;
            color: #455560;
        }
        .price{
            font-weight: 400;
            font-size: 12px;
            line-height: 140%;
            color: #676F7C;
        }
    }
    }
}

`;
export default StyleWrapper;
